/**
 * Performs a shallow equality check between two objects
 * Returns true if both objects have the same keys and values (===)
 * @param a - First object to compare
 * @param b - Second object to compare
 * @returns true if objects are shallowly equal, false otherwise
 */
export function shallowEqual(a: any, b: any): boolean {
  if (a === b) return true;
  if (!a || !b) return false;
  if (typeof a !== "object" || typeof b !== "object") return false;

  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) return false;

  for (const key of aKeys) {
    if (a[key] !== b[key]) return false;
  }

  return true;
}

